<template>
	<div class="container">
		<div class="base-div">
			<div class="create">
				<h3 class="create-h3">发表留言</h3>
				<div class="create-title">
					<input maxlength="80" type="text" v-model="title" placeholder="请输入标题"/>
					<span>还可输入{{titleLength}}个字符</span>
				</div>
				<div style="border: 1px solid #EBEBEB;">
					<Toolbar
						style="border-bottom: 1px solid #EBEBEB"
						:editor="editor"
						:defaultConfig="toolbarConfig"
						:mode="mode"
					/>
					<Editor
						style="height: 300px; overflow-y: hidden;"
						v-model="html"
						:defaultConfig="editorConfig"
						:mode="mode"
						@onCreated="onCreated"
					/>
				</div>
				<div class="create-btn" @click="createMessage">发表留言</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue'
	import '@wangeditor/editor/dist/css/style.css'
	import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
	import qs from 'qs'
	import { post, config, ajaxParam } from '@/units/request.js'
	export default Vue.extend({
		name: 'MessageCreate',
		components: { Editor, Toolbar },
		data() {
			return {
				activityId: '',
				userId: '',
				title: '',
				editor: null,
				html: '',
				toolbarConfig: {
					excludeKeys: [
						'insertVideo'
					]
				},
				editorConfig: {
					placeholder: '请输入内容...' ,
					MENU_CONF: {
						uploadImage: {
							server: config.baseUrl + "v1/upload/editorUpload",
							fieldName: "file"
						}
					}
				},
				mode: 'simple', // or 'simple'
				titleLength: 80
			}
		},
		watch: {
			title(newVal){
				console.log(newVal)
				this.titleLength = 80-newVal.length
				if(this.titleLength<=0) {
					this.titleLength = 0
				}
			}
		},
		methods: {
			onCreated(editor) {
				this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
			},
			titleChange(e){
				console.log(e)
			},
			//发表留言
			async createMessage(){
				if(this.title.length<=0){
					this.$message.error('标题不能为空！')
					return
				}
				if(this.html.length<=0||this.html=='<p><br></p>'){
					this.$message.error('请输入留言，不能为空！')
					return
				}
				let url = 'v1/suggest/create'
				let param = {
          token:localStorage.getItem('token'),
          uuid: localStorage.getItem('uuid'),
          activityId: this.activityId,
					title: this.title,
					content: this.html,
					addUserId: this.userId
				}
				ajaxParam(param)
				const res = await post(url, qs.stringify(param))
				if(res.data.code==200) {
					this.$message.success('留言成功！')
					setTimeout(()=>{
						this.$router.push({
							path: '/messageBoard/messageNew'
						})
					},300)
				} else {
					this.$message.error(res.data.msg)
				}
			}
		},
		mounted() {
		// 模拟 ajax 请求，异步渲染编辑器
			// setTimeout(() => {
			// 	this.html = '<p>模拟 Ajax 异步设置内容 HTML</p>'
			// }, 1500)
			this.userId = localStorage.getItem('userId')
			this.activityId = localStorage.getItem('activityId')
		},
		beforeDestroy() {
			const editor = this.editor
			if (editor == null) return
			editor.destroy() // 组件销毁时，及时销毁编辑器
		}
	})
</script>

<style scoped lang="less">
	.container{
		background:#f7f7f7;
		overflow: hidden;
	}
	.base-div{
		margin-top: 20px;
		margin-bottom: 20px;
		background: #fff;
		padding-top: 10px;
	}
	.create{
		padding: 20px 40px;
		.create-h3{
			font-weight: bold;
		}
		.create-title{
			display: flex;
			align-items: center;
			margin: 22px 0 15px;
			input{
				width: 312px;
				height: 22px;
				padding: 5px 10px;
				border: 1px solid #EBEBEB;
			}
			span{
				margin-left: 10px;
				font-size: 12px;
				color: #4a4a4a;
			}
		}
		/deep/ .w-e-bar{
			background-color: #f7f7f7;
		}
	}

</style>
